var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "15 15 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    d: "M33.072 17.558h-.03v1.232h-1.079V32.69A2.308 2.308 0 0 1 29.652 35H19.39a2.308 2.308 0 0 1-2.311-2.311V18.79H16v-1.232h5.362v-1.079c0-.863.616-1.479 1.48-1.479h3.39c.862 0 1.478.616 1.478 1.48v1.078h5.362zm-10.477-1.079v1.079h3.913v-1.079c0-.185-.061-.246-.246-.246h-3.42c-.186 0-.247.061-.247.246zm8.166 16.24h.031V18.79h-12.45v13.93c0 .585.462 1.078 1.079 1.078h10.262c.585 0 1.078-.462 1.078-1.078zM23.92 21.596h1.233v9.399H23.92v-9.4zm3.42 0h1.233v9.399h-1.232v-9.4zm-6.84 0h1.232v9.399h-1.233v-9.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.b46d04fddce5413da85913cb76ce8509.svg";
export { ForwardRef as ReactComponent };